import { SaleTransactionType } from 'api-hooks/refund/refund';
import HOCWatchValue from 'components/common/hoc-watch-value';
import { Input } from 'components/elements';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

export default function PurchaseRefundField() {
  const { t } = useTranslation();
  const { setValue } = useFormContext<any>();

  const values = HOCWatchValue({
    keys: [
      'transactionSaleType',
      'flightPurchases',
      'hotelPurchases',
      'activityPurchases',
      'cruisePurchases',
      'documentPurchases',
    ],
  });

  React.useEffect(() => {
    if (values.transactionSaleType === SaleTransactionType.FLIGHT) {
      const guestPurchaseAmount = values.flightPurchases
        .filter((fs) => fs.flightPurchaseGuests.some((fst) => fst.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const parentTemp = parentCurr.flightPurchaseGuests
            .filter((fsg) => fsg.isSelected)
            .reduce((prev, curr) => {
              return prev + curr.refundPrice;
            }, 0);
          return parentPrev + parentTemp;
        }, 0);

      const addOnsPurchaseAmount = values.flightPurchases
        .filter((fs) => fs.flightPurchaseAddOns.some((fst) => fst.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const parentTemp = parentCurr.flightPurchaseAddOns
            .filter((fsg) => fsg.isSelected)
            .reduce((prev, curr) => {
              return prev + curr.refundPrice;
            }, 0);
          return parentPrev + parentTemp;
        }, 0);

      setValue(
        'releasePurchase.amount',
        guestPurchaseAmount + addOnsPurchaseAmount,
      );
    } else if (values.transactionSaleType === SaleTransactionType.HOTEL) {
      const amount = values.hotelPurchases
        .filter((hs) => hs.isSelected)
        .reduce((parentPrev, parentCurr) => {
          const roomAmount = parentCurr.hotelPurchaseHotels.reduce(
            (prev, curr) => prev + curr.refundPrice,
            0,
          );
          const addonsAmount = parentCurr.hotelPurchaseAddOns
            .filter((hsao) => hsao.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);

          return parentPrev + roomAmount + addonsAmount;
        }, 0);
      setValue('releasePurchase.amount', amount);
    } else if (values.transactionSaleType === SaleTransactionType.CRUISE) {
      const guestAmount = values.cruisePurchases
        .filter((cs) => cs.cruisePurchaseDetails.some((cst) => cst.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const amount = parentCurr.cruisePurchaseDetails
            .filter((csg) => csg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + amount;
        }, 0);
      const addonsAmount = values.cruisePurchases
        .filter((cs) => cs.cruisePurchaseAddOns.some((cst) => cst.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const amount = parentCurr.cruisePurchaseAddOns
            .filter((csg) => csg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + amount;
        }, 0);
      setValue('releasePurchase.amount', guestAmount + addonsAmount);
    } else if (values.transactionSaleType === SaleTransactionType.ACTIVITY) {
      const guestAmount = values.activityPurchases
        .filter((as) => as.activityPurchaseGuests.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.activityPurchaseGuests
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);

      const addonsAmount = values.activityPurchases
        .filter((as) => as.activityPurchaseAddOns.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.activityPurchaseAddOns
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);
      setValue('releasePurchase.amount', guestAmount + addonsAmount);
    } else if (values.transactionSaleType === SaleTransactionType.DOCUMENT) {
      const guestAmount = values.documentPurchases
        .filter((as) => as.documentPurchaseGuests.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.documentPurchaseGuests
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);

      const addonsAmount = values.documentPurchases
        .filter((as) => as.documentPurchaseAddOns.some((ast) => ast.isSelected))
        .reduce((parentPrev, parentCurr) => {
          const temp = parentCurr.documentPurchaseAddOns
            .filter((asg) => asg.isSelected)
            .reduce((prev, curr) => prev + curr.refundPrice, 0);
          return parentPrev + temp;
        }, 0);
      setValue('releasePurchase.amount', guestAmount + addonsAmount);
    }
  }, [setValue, values]);

  return (
    <Input
      type="number"
      name="releasePurchase.amount"
      label={t('refund:refund_amount')}
      placeholder={t('refund:refund_amount')}
      disabled
    />
  );
}
